<script setup lang="ts">
import type { LogoItem } from './LogoLoop.vue'

defineOptions({
  name: 'LogoContent'
})

defineProps<{
  item: LogoItem
  scaleOnHover?: boolean
}>()
</script>

<template>
  <Icon
    :name="item.icon"
    size="var(--logoloop-logoHeight)"
    :class="
      cn(
        'shadow lg:h-16 lg:w-40 p-1 bg-white dark:bg-surface-container-highest rounded-xl object-contain dark:text-inherit',
        item.class
      )
    "
  />
</template>
